import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDateRange, formatPrice } from '../utils/formatters';

function BedIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 18v-6a2 2 0 012-2h14a2 2 0 012 2v6M3 18v2M3 18h18M21 18v2M5 10V7a2 2 0 012-2h2a2 2 0 012 2v3m2 0V8a2 2 0 012-2h2a2 2 0 012 2v2" />
    </svg>
  );
}

function PersonIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="8" r="3.2" />
      <path strokeLinecap="round" d="M5 20c0-3.3 3.1-6 7-6s7 2.7 7 6" />
    </svg>
  );
}

export default function ListingCard({ listing, roomType, horizontal = false }) {
  const navigate = useNavigate();
  const img = listing.image_urls?.[0] || listing.property_image_urls?.[0];

  const hasDiscount = listing.ceiling_price && listing.current_price < listing.ceiling_price;
  const discountPct = hasDiscount
    ? Math.round((listing.ceiling_price - listing.current_price) / listing.ceiling_price * 100)
    : 0;

  return (
    <div
      className={`card listing-card${horizontal ? ' listing-card-horizontal' : ''}`}
      onClick={() => navigate(`/listings/${listing.id}`)}
    >
      <div className="listing-card-img-wrap">
        {img ? (
          <img src={img} alt={listing.property_name} />
        ) : (
          <div className="listing-card-img-fallback">
            {listing.property_name}
          </div>
        )}
        <div className="listing-card-img-gradient" />
        {hasDiscount && (
          <span className="listing-card-discount-pill">{discountPct}% off</span>
        )}
      </div>

      <div className="listing-card-body">
        <div className="listing-card-property">{listing.property_name}</div>
        <div className="listing-card-unit-dates">
          {listing.unit_number && <span>{listing.unit_number} · </span>}
          {formatDateRange(listing.check_in_date, listing.check_out_date)}
        </div>

        <div className="listing-card-price-row">
          <span className="listing-card-price">{formatPrice(listing.current_price)}</span>
          {hasDiscount && (
            <span className="listing-card-price-strike">{formatPrice(listing.ceiling_price)}</span>
          )}
        </div>

        <div className="listing-card-icon-row">
          {roomType && (
            <span className="listing-card-icon-item">
              <BedIcon />
              {roomType}
            </span>
          )}
          <span className="listing-card-icon-item">
            <PersonIcon />
            {listing.max_guests} guest{listing.max_guests !== 1 ? 's' : ''}
          </span>
        </div>

        <div className="listing-card-cta">
          View Stay <span aria-hidden="true">→</span>
        </div>
      </div>
    </div>
  );
}
